<template>
  <div>
      <div class="col-md-12">
          <form class="form-horizontal">
              <div class="row">
                  <div class="panel panel-default">
                      <div class="panel-heading clearfix">
                          <h3 class="panel-title pull-left">
                              Editar
                          </h3>
                      </div>
                      <div class="panel-body">

                          <div class="container">

                              <div class="form-group">
                                  <div class="col-md-2 control-label"><label for="name">Nome <span class="text-danger">*</span></label></div>
                                  <div class="col-md-10">
                                      <input type="text" id="name" class="form-control" v-model="form.name" required>
                                  </div>
                              </div>

                              <div class="form-group">
                                  <div class="col-md-2 control-label"><label for="title">Titulo <span class="text-danger">*</span></label></div>
                                  <div class="col-md-10">
                                      <input type="text" id="title" class="form-control" v-model="form.title" required>
                                  </div>
                              </div>

                              <div class="form-group">
                                  <div class="col-md-2 control-label"><label for="text">Texto <span class="text-danger">*</span></label></div>
                                  <div class="col-md-10">
                                      <input type="text" id="text" class="form-control" v-model="form.text" required>
                                  </div>
                              </div>

                              <div class="form-group">
                                  <div class="col-md-2 control-label"><label for="sub_text">Segundo Texto <span class="text-danger">*</span></label></div>
                                  <div class="col-md-10">
                                      <input type="text" id="sub_text" class="form-control" v-model="form.sub_text" required>
                                  </div>
                              </div>

                              <div class="form-group">
                                  <div class="col-md-2 control-label"><label for="url">Link</label></div>
                                  <div class="col-md-10">
                                      <input type="text" id="url" class="form-control" v-model="form.url" required>
                                  </div>
                              </div>

                              <div class="form-group">
                                  <div class="col-md-2 control-label"><label for="url_target">Abrir link em <span class="text-danger">*</span></label></div>
                                  <div class="col-md-10">
                                      <select id="url_target" class="form-control" v-model="form.url_target" required>
                                          <option value="">Selecione...</option>
                                          <option value="_self">Mesma janela...</option>
                                          <option value="_blank">Nova janela...</option>
                                      </select>
                                  </div>
                              </div>

                              <div class="form-group">
                                  <div class="col-md-2 control-label"><label for="show_mode">Exibir para <span class="text-danger">*</span></label></div>
                                  <div class="col-md-10">
                                      <select id="show_mode" class="form-control" v-model="form.show_mode" required>
                                          <option value="">Selecione...</option>
                                          <option value="all">Todos</option>
                                          <option value="registered">Somente logados</option>
                                      </select>
                                  </div>
                              </div>

                              <div class="form-group">
                                  <div class="col-md-2 control-label"><label for="image">Imagem <span class="text-danger">*</span></label></div>
                                  <div class="col-md-10">
                                      <div class="row" v-if="form.image">
                                          <div class="col-md-12">
                                              <img :src="form.image" width="500" height="auto"/>
                                          </div>
                                      </div>
                                      <br/>
                                      <div class="row">
                                          <div class="col-md-3">
                                              <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#modal-filemanager">Selecionar arquivo</button>
                                          </div>
                                          <div class="col-md-3">
                                              <button v-if="form.image" type="button" class="btn btn-danger" @click="removeFile">Remover</button>
                                          </div>
                                      </div>
                                      <br/>
                                      <div class="row">
                                          <div class="col-md-12">
                                              <p>
                                                  Imagem no formato <strong>1016x517px</strong>, sendo que a mesma será aplicada automaticamente na posição necessária para compor o banner.
                                                  Preferencialmente com peso abaixo de <strong>100KB</strong>
                                              </p>
                                          </div>
                                      </div>
                                  </div>
                              </div>

                              <div class="form-group">
                                  <div class="col-md-2 control-label"><label for="arquivo_pt"></label></div>
                                  <div class="col-md-10">
                                      <span class="text-danger"><b>ATENÇÃO!!</b> Devido as diferentes resoluções de computadores, o preview pode não estar 100% fiel a realidade, use-o apenas como referência.</span>
                                  </div>
                              </div>

                              <div class="form-group">
                                  <div class="col-md-2 control-label"><label for="imagem">Preview</label></div>
                                  <div class="col-md-10">
                                      <div class="col-md-7">
                                          <div class="row">
                                              <div class="col-md-12" style="padding: 0;">
                                                  <img :src="'/public/preview-banner/powertech/powertech-top.png'" style="max-width: 100%"/>
                                              </div>
                                          </div>
                                          <div class="row">
                                              <div class="col-md-2 m-0" style="padding-right: 0; height: 157px; background-color: #15153b">
                                                  <img :src="'/public/preview-banner/powertech/left.png'" style="max-width: 100%; height: 100%"/>
                                              </div>
                                              <div class="col-md-8 m-0 text-center" style="padding: 0; z-index: 999; background-color: #15153b">
                                                  <div class="banner-vue">
                                                      <img class="text-center image-banner-vue" v-if="form.image" :src="form.image" style="max-width: 100%; max-height: 157px; float: right"/>
                                                      <div class="col-md-5 text-left p-0" style="position: absolute; top:20px; left: 10px; z-index: 9999">
                                                          <div style="border-left: 5px solid #ed2e30; color: #fff; font-size: 7px; z-index: 9999;">
                                                              <b>{{ form.title }}</b>
                                                          </div>
                                                          <div style="color: #ed2e30; font-size: 14px; margin-top: 7px">
                                                              <b>{{ form.text }}</b>
                                                          </div>
                                                          <div style="color: #fff; font-size: 7px; margin-top: 7px">
                                                              {{ form.sub_text }}
                                                          </div>
                                                          <a :href="form.url" :target="form.url_target" style="background-color: #ed2e30; padding: 3px 7px; border-radius: 50px; color: #fff; font-size: 5px; z-index: 9999; text-transform: uppercase; margin-top: 7px">
                                                              Clique aqui
                                                          </a>
                                                      </div>
                                                  </div>
                                              </div>
                                              <div class="col-md-2 m-0" style="padding-left: 0; height: 157px; background-color: #15153b">
                                                  <img :src="'/public/preview-banner/powertech/right.png'" style="max-width: 100%; height: 100%"/>
                                              </div>
                                          </div>
                                          <div class="row">
                                              <div class="col-md-12" style="padding: 0">
                                                  <img :src="'/public/preview-banner/powertech/powertech-bottom.png'" style="max-width: 100%"/>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>

                              <div class="form-group">
                                  <div class="col-md-2 control-label"><label for="active">Ativo <span class="text-danger">*</span></label></div>
                                  <div class="col-md-10">
                                      <select id="active" class="form-control" v-model="form.active" required>
                                          <option value="">Selecione...</option>
                                          <option value="1">Sim</option>
                                          <option value="0">Não</option>
                                      </select>
                                  </div>
                              </div>

                              <div class="form-group">
                                  <div class="col-md-12 text-center">
                                      <button class="btn btn-primary" type="button" @click="sendForm" v-if="this.id_banner">Atualizar</button>
                                      <button class="btn btn-primary" type="button" @click="sendForm" v-else>Salvar</button>
                                  </div>
                              </div>
                          </div>
                      </div>

                      <div class="text-right">
                      </div>
                  </div>
              </div>
          </form>
      </div>

      <file-manager @fileSelected="getFileSelected"></file-manager>
  </div>
</template>

<script>

import axios from "axios";
import Swal from 'sweetalert2';
import FileManager from '../../../../components/c-atlas-filemanager.vue'

export default {
    name: 'BannerHome',
    components: { 'file-manager': FileManager },
    props: ['id_banner'],
    data() {
        return {
            form: {
                name       : '',
                title      : '',
                text       : '',
                sub_text   : '',
                url        : '',
                url_target : '',
                show_mode  : '',
                image      : '',
                active     : '',
            }
        }
    },
    beforeMount() {
        var _this = this;

        if (this.id_banner) {
            axios.get(_ROOT_PATH +'/admin/powertech-banner/buscar-cadastro/' + this.id_banner)
                .then(function (response) {
                    _this.form.name       = response.data.name;
                    _this.form.title      = response.data.title;
                    _this.form.text       = response.data.text;
                    _this.form.sub_text   = response.data.sub_text;
                    _this.form.url        = response.data.url;
                    _this.form.url_target = response.data.url_target;
                    _this.form.show_mode  = response.data.show_mode;
                    _this.form.image      = _PUBLIC_PATH + '/' + response.data.image;
                    _this.form.active     = response.data.active;
                }).catch(function (error) {
                console.error(error);
            });
        }

    },
    methods: {
        sendForm () {
            var _this = this;
            if (!this.form.name || !this.form.title || !this.form.text || !this.form.sub_text || !this.form.url_target || !this.form.show_mode || !this.form.image || !this.form.active) {
                Swal.fire({
                    title: 'Oops!',
                    text: 'Você deve preencher todos os campos obrigatórios.',
                    type: 'error',
                    confirmButtonColor: '#d63030',
                    confirmButtonText: 'Ok!'
                });
            } else {
                if (this.id_banner) {
                    axios.post(_ROOT_PATH + '/admin/powertech-banner/atualizar/' + this.id_banner, this.form)
                        .then(function (response) {
                            if (response.data.status) {
                                Swal.fire({
                                    title: 'Sucesso!',
                                    text: 'Banner atualizado com sucesso!',
                                    type: 'success',
                                    confirmButtonColor: '#358f06',
                                    confirmButtonText: 'Obrigado!'
                                }).then((result) => {
                                    window.location.href = _ROOT_PATH + "/admin/powertech-banner/";
                                });
                            }
                        }).catch(function (error) {
                        Swal.fire({
                            title: 'Oops!',
                            text: 'Ocorreu um erro ao salvar o banner.',
                            type: 'error',
                            confirmButtonColor: '#d63030',
                            confirmButtonText: 'Ok!'
                        });
                        console.error(error);
                    });
                } else {
                    axios.post(_ROOT_PATH + '/admin/powertech-banner/salvar/', this.form)
                        .then(function (response) {
                            if (response.data.status) {
                                Swal.fire({
                                    title: 'Sucesso!',
                                    text: 'Banner salvo com sucesso!',
                                    type: 'success',
                                    confirmButtonColor: '#358f06',
                                    confirmButtonText: 'Obrigado!'
                                }).then((result) => {
                                    window.location.href = _ROOT_PATH + "/admin/powertech-banner/";
                                });
                            }
                        }).catch(function (error) {
                        Swal.fire({
                            title: 'Oops!',
                            text: 'Ocorreu um erro ao salvar o banner.',
                            type: 'error',
                            confirmButtonColor: '#d63030',
                            confirmButtonText: 'Ok!'
                        });
                        console.error(error);
                    });
                }
            }
        },
        getFileSelected (value) {
            this.form.image = value.url
            document.getElementById('close-modal').click();
        },
        removeFile () {
            this.form.image = '';
        }
    }
}
</script>

<style lang="scss" scoped>
    .banner-vue:before {
        position: absolute;
        top: 0;
        left: 0;
        width: 60%;
        height: 100%;
        z-index: 3;
        content: "";
        background: #15153b;
        background: linear-gradient(90deg,#15153b,rgba(21,21,59,0));
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=$primary,endColorstr=$primary,GradientType=1);
    }

    .banner-vue:after {
        position: absolute;
        top: 0;
        right: 0;
        width: 20%;
        height: 100%;
        z-index: 3;
        content: "";
        background: #15153b;
        background: linear-gradient(90deg,rgba(21,21,59,0),#15153b);
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=$primary,endColorstr=$primary,GradientType=1);
    }

    .image-banner-vue {
        opacity: .5;
        height: 100%;
        display: block;
        margin: 0 0 0 auto;
    }

</style>